/** 与 RichTextEditor `floating/table/constants` 对齐（画布坐标，随 stage 缩放） */

/** 行列拖拽重排：指针位移超过该阈值后才进入 dragging */
export const TABLE_DRAG_THRESHOLD_PX = 16;

/** 表格外侧「添加行」操作条高度 */
export const TABLE_ADD_ROW_STRIP_HEIGHT_PX = 32;

/** 表格外侧「添加列」操作条宽度 */
export const TABLE_ADD_COL_STRIP_WIDTH_PX = 32;

/** 加行/加列条内图标尺寸（条带尺寸的 2/3） */
export const TABLE_ADD_STRIP_ICON_PX = Math.round((TABLE_ADD_ROW_STRIP_HEIGHT_PX * 2) / 3);

/** 表格边框与外侧加行/加列条之间的间距 */
export const TABLE_ADD_STRIP_GAP_PX = 8;

/** 行轴握把（左侧拖拽柄）宽度 */
export const TABLE_ROW_GRIP_WIDTH_PX = 16;

/** 行轴握把高度 */
export const TABLE_ROW_GRIP_HEIGHT_PX = 24;

/** 列轴握把（顶部拖拽柄）宽度 */
export const TABLE_COL_GRIP_WIDTH_PX = 24;

/** 列轴握把高度 */
export const TABLE_COL_GRIP_HEIGHT_PX = 16;

/** 列宽调整热区宽度（列分隔线两侧可点击区域） */
export const COL_RESIZE_HIT_PX = 14;

/** 行高调整热区高度（行分隔线上下可点击区域） */
export const ROW_RESIZE_HIT_PX = 14;

/**
 * 行内格式工具条（InlineToolbar）底边与表格顶边之间的视口间距（px）。
 * InlineToolbar 以 selectionRect.top 为锚点，向上偏移约 38px（工具条高度 ≈ 30px + 此 gap）。
 * 因此传入 selectionRect.top = tableRect.top 时，工具条底边距表格顶边恰好为此值。
 */
export const TABLE_INLINE_TOOLBAR_GAP_PX = 8;
